export function toCapitalize(text) {
  if (!text) {
    return;
  }
  const lower = text.toLowerCase();
  return text.charAt(0).toUpperCase() + lower.slice(1);
}
